import { render } from "./settings-item-box.vue?vue&type=template&id=a4091b5e&scoped=true"
import script from "./settings-item-box.vue?vue&type=script&lang=js"
export * from "./settings-item-box.vue?vue&type=script&lang=js"

import "./settings-item-box.vue?vue&type=style&index=0&id=a4091b5e&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4091b5e"]])

export default __exports__